export default function clone(obj = {}, boolean) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      if (boolean) {
        var arr = []
        for (const prop in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            arr[prop] = clone(obj[prop], boolean)
          }
        }
        return arr
      } else {
        return obj.slice()
      }
    } else {
      var Obj = {}
      if (boolean) {
        for (const prop in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            Obj[prop] = clone(obj[prop], boolean)
          }
        }
        return Obj
      } else {
        for (const prop in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            Obj[prop] = obj[prop]
          }
        }
        return Obj
      }
    }
  } else {
    return obj
  }
}
